import { css } from "../../../../../styled-system/css";

export const styles = {
  wrapper: () =>
    css({
      gridArea: "contentAfterRecordCheck",
      display: "flex",
      flexDirection: "column",
      width: "100%",
      "& form": {
        marginLeft: "0",
        marginTop: "baseUnit.mobile3",
        marginBottom: "baseUnit.mobile2",
        tabletLandscape: {
          marginLeft: "0",
        },
      },
    }),
  vinMessage: () =>
    css({
      fontSize: "body.cat",
      lineHeight: "body.cat",
      letterSpacing: "body.cat",
      desktop: {
        fontSize: "body.horse",
        lineHeight: "body.horse",
        letterSpacing: "body.horse",
      },
    }),
  vhrFound: () =>
    css({
      textAlign: "start",
      lineHeight: "body.horse",
      fontSize: "body.horse",
      fontWeight: 700,
    }),
  buttonWrapper: () =>
    css({
      display: "flex",
      flexDirection: "column",
      gap: "baseUnit.mobile2",
      width: "100%",
      marginTop: "baseUnit.mobile2",
      marginBottom: "0",
      tablet: {
        flexDirection: "row",
        flexWrap: "wrap",
        alignItems: "flex-start",
      },
      desktop: {
        marginTop: "baseUnit.mobile3",
      },
    }),
  button: () =>
    css({
      width: "100%",
      mobile: {
        width: "auto",
      },
    }),
};
